export default {"src":"/_next/static/media/paidFast.20da1630.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};